import { axiosEjFetch } from "./axiosEjHelpers";

export interface StartMagicAiPaymentRequest {
  reservationId: string;
  successUrl: string;
  cancelUrl: string;
  aiBudgetPriceId?: string;
}

export interface StartMagicAiPaymentResponse {
  success: boolean;
  gatewayUrl?: string;
  validationErrors?: string[];
}

export async function startMagicAiPayment(
  request: StartMagicAiPaymentRequest
) {
  return axiosEjFetch.safePost<
    StartMagicAiPaymentRequest,
    undefined,
    undefined,
    StartMagicAiPaymentResponse
  >("/api/magicaipayment/start", request);
}

export interface AiBudgetPriceDto {
  id: string;
  name: string;
  sortOrder: number;
  isRecommended: boolean;
  budgetUsd: number;
  grossPrice: number;
  grossPriceBeforeDiscount: number | null;
  maxGuests: number;
  aiPhotoCount: number;
  aiVideoCount: number;
  includesIndividual: boolean;
  currencyCode: string;
}

export interface GetAiBudgetPricesResponse {
  success: boolean;
  packages: AiBudgetPriceDto[];
  validationErrors?: string[];
}

export async function getAiBudgetPrices(reservationId: string): Promise<GetAiBudgetPricesResponse> {
  return axiosEjFetch.safeGet<undefined, undefined, GetAiBudgetPricesResponse>(
    `/api/aibudgetprice/byReservation/${reservationId}`
  );
}
